import axios from "./axios";
import AppConfig from "../../config";

export default class authenService {
  login = async (body) => {
    //console.log('BASE_URL:', `${AppConfig.BASE_URL}`);
    const url = `${AppConfig.BASE_URL}:${AppConfig.AUTHEN_PORT}/auth/realms/master/protocol/openid-connect/token`;
    //console.log("loginAuthen url", url);
    const config = {
      method: 'post',
      url: url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const response = await axios.post(url, body, config);
    return response.data;
  };

  refreshToken = async (token) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.AUTHEN_PORT}/auth/realms/master/protocol/openid-connect/token`;
    //console.log("refreshToken url", url);
    const config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    const body = {
      client_id: `${AppConfig.CLIENT_ID}`,
      client_secret: `${AppConfig.CLIENT_SECRET}`,
      grant_type: `${AppConfig.GRANT_TYPE_REFRESH}`,
      refresh_token: token,
    };
    const response = await axios.post(url, body, config);
    //console.log("refreshToken response: ", JSON.stringify(response));
    return response;
  };

  logout = async (body) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.AUTHEN_PORT}/auth/realms/master/protocol/openid-connect/logout`;
    //console.log("logout url", url);
    const config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    const results = await axios.post(url, body, config);
    const response = await results.data;
    //console.log("signout response: ", JSON.stringify(response));
    return response;
  };
}

export { authenService }